// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"c91f7d00","266":"619521a9","283":"26d12fc5","387":"9dcb8e88","812":"a569e482"}[chunkId] + ".chunk.css";
};